import React from "react";
import TextFilter from "./TextFilter";
import NumberFilter from "./NumberFilter";
import SelectFilter from "./SelectFilter";
import MultiSelectFilter from "./MultiSelectFilter";
import DateFilter from "./DateFilter";

type FilterType = 'text' | 'number' | 'select' | 'multiSelect' | 'date';

export interface FilterConfig {
    type: FilterType;
    options?: { label: string; value: string }[];
    min?: number;
    max?: number;
}

interface FilterConfigProps {
    label?: string;
    type: FilterType;
    options?: { label: string; value: string }[];
    min?: number;
    max?: number;
}

interface FilterRendererProps {
    config: FilterConfigProps;
    value: any;
    setFilter: (value: string) => void;
    removeFilter: () => void;
    isMobile: boolean;
}

const FilterRenderer: React.FC<FilterRendererProps> = ({
                                                           config,
                                                           value,
                                                           setFilter,
                                                           removeFilter,
                                                           isMobile
                                                       }) => {
    const label = config.label ?? '';
    switch (config.type) {
        case 'text':
            return <TextFilter label={label} value={value} setFilter={setFilter}
                               removeFilter={removeFilter} isMobile={isMobile}/>;
        case 'number':
            return <NumberFilter label={label} value={value} setFilter={setFilter}
                                 removeFilter={removeFilter}
                                 min={config.min} max={config.max}
                                 isMobile={isMobile}/>;
        case 'select':
            return <SelectFilter label={label} value={value} setFilter={setFilter}
                                 removeFilter={removeFilter}
                                 options={config.options || []} isMobile={isMobile}/>;
        case 'date':
            return <DateFilter label={label} value={value} setFilter={setFilter}
                               isMobile={isMobile}/>;
        case 'multiSelect':
            return <MultiSelectFilter label={label} value={value} setFilter={setFilter}
                                      removeFilter={removeFilter}
                                      options={config.options || []} isMobile={isMobile}/>;
        default:
            return null;
    }
};

export default FilterRenderer;